// extracted by mini-css-extract-plugin
export var blog_img = "index-module--blog_img--2066f";
export var blog_list = "index-module--blog_list--230c4";
export var blog_list_container = "index-module--blog_list_container--c48f2";
export var blog_text = "index-module--blog_text--be366";
export var category = "index-module--category--d3357";
export var date = "index-module--date--9397e";
export var date_category = "index-module--date_category--bbab2";